// --------------
// Obtienes todos los productos de la tienda como "product-cards" en un array
// Se necesita el template "index.all_products_dom.liquid"
// --------------
window.getProductsDOMAjax = async (nextPage) => {
  const result = await window.fetch(
    `${window.location.origin}/collections/${window.collectionHandle}?view=all_products_dom&page=${nextPage}`,
  );
  const htmlText = await result.text();
  const htmlContent = new window.DOMParser().parseFromString(
    htmlText,
    'text/html',
  );

  return htmlContent.querySelector('body');
};

window.setAllProductsDOM = () => {
  const totalPages = Math.ceil(window.collectionProductsCount / 80);
  let allProducts = [];
  const allAjax = [];

  for (let nextPage = 1; nextPage <= totalPages; nextPage++) {
    allAjax.push(window.getProductsDOMAjax(nextPage));
  }

  const setAjaxElementsDOM = async () => {
    const results = await Promise.all(allAjax);

    results.forEach((body) => {
      const $itemsSiblingsAjax = Array.from(
        body.querySelector('#all-products-dom')?.children ?? [],
      );

      $itemsSiblingsAjax.forEach(($element) => {
        allProducts = [...allProducts, $element];
      });
    });

    window.allProductsDOM = allProducts;
    window.dispatchEvent(new window.Event('allProductsDOMReady'));
  };

  setAjaxElementsDOM();
};

window.setAllProductsDOM();
